import base from '../../utils/apiService';

/**
 * Named `apiService` export for Redux slices — same Axios instance and auth behavior
 * as `@/utils/apiService` (401 → refresh cookie, no client-side “JWT expired” logout).
 * Extends the default client with thin route helpers used by older slices.
 */
export const apiService = {
    ...base,

    getUsers() {
        return base.request('/users', { method: 'GET' });
    },
    getUserById(id) {
        return base.request(`/users/${id}`, { method: 'GET' });
    },
    createUser(userData) {
        return base.request('/users', { method: 'POST', body: userData });
    },
    updateUser(id, userData) {
        return base.request(`/users/${id}`, { method: 'PUT', body: userData });
    },
    deleteUser(id) {
        return base.request(`/users/${id}`, { method: 'DELETE' });
    },
    getPosts() {
        return base.request('/posts', { method: 'GET' });
    },
    getPostsByUserId(userId) {
        return base.request(`/posts?userId=${userId}`, { method: 'GET' });
    },
    createPost(postData) {
        return base.request('/posts', { method: 'POST', body: postData });
    },
    updatePost(id, postData) {
        return base.request(`/posts/${id}`, { method: 'PUT', body: postData });
    },
    deletePost(id) {
        return base.request(`/posts/${id}`, { method: 'DELETE' });
    },
    getBotById(botId) {
        return base.request(`/bots/${botId}`, { method: 'GET' });
    },
    getBotStatus(botId) {
        return base.request(`/bots/${botId}/status`, { method: 'GET' });
    },
    getBotErrors(botId) {
        return base.request(`/bots/${botId}/errors`, { method: 'GET' });
    },
    startBot(botId) {
        return base.request(`/bots/${botId}/start`, { method: 'POST' });
    },
    stopBot(botId) {
        return base.request(`/bots/${botId}/stop`, { method: 'POST' });
    },
    deleteBot(botId) {
        return base.request(`/bots/${botId}`, { method: 'DELETE' });
    },
    updateBotGasFees(botId, gasAmount) {
        return base.request(`/bots/${botId}/gas-fees`, { method: 'PUT', body: { gasAmount } });
    },
    createBot(botData) {
        return base.request('/bots', { method: 'POST', body: botData });
    },
    getTokenVolume(tokenAddress) {
        return base.request(`/tokens/${tokenAddress}/volume`, { method: 'GET' });
    },
    getMultipleTokenVolumes(tokenAddresses) {
        return base.request('/tokens/volumes', { method: 'POST', body: { tokenAddresses } });
    },
    getGasLevel(botId, totalBalance) {
        return base.request('/gas/level', { method: 'POST', body: { botId, totalBalance } });
    },
    getBotBalance(botId) {
        return base.request(`/bots/${botId}/balance`, { method: 'GET' });
    },
};

export default apiService;
